const doc = [({"en":({"js":({"admin":({"teams":({"show":({"add_user":"Add user", "the_team_was_deleted":"The team was deleted", "team_members":"Team members:"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;